import dayjs from "dayjs"
import { OrderType } from "../types"
import { Tag } from "antd"

type ListOfOrdersType = {
    orders: OrderType[]
    openModal: (e: OrderType) => void
}

export default function ListOfOrders(props: ListOfOrdersType) {
    return (
        <div className="flex flex-col bg-white w-1/2 shadow-lg rounded-default p-4 h-full">
            <h3 className="font-bold text-xl uppercase underline">Aktive Aufträge</h3>
            <div className="overflow-y-scroll h-[70%]">
                {(!props.orders || props.orders?.length === 0) && (
                    <p className="text-gray-300 text-xs font-semibold text-start pt-2 pl-2">Bisher keine Aufträge gestellt</p>
                )}
                {props.orders && props.orders?.map((item) => <OrderElement item={item} openModal={() => props.openModal(item)} />)}
            </div>
        </div>
    )
}

type OrderElementType = {
    item: OrderType
    openModal: () => void
}

function OrderElement(props: OrderElementType) {
    return (
        <div onClick={props.openModal} className="flex flex-row border-b p-4 text-sm items-center justify-between z-10 cursor-pointer">
            <p className=" font-semibold w-64 ">{props.item.requestTask}</p>
            <p className="text-black/30 text-xs font-semibold">vom {dayjs(props.item?.createdAt).format("DD.MM.YYYY")}</p>
            <p className="truncate w-48 text-xs text-black/30 font-semibold">
                {props.item.object
                    ? props.item.object.adress.street +
                      " " +
                      props.item.object.adress.nr +
                      ", " +
                      props.item.object.adress.plz +
                      " " +
                      props.item.object.adress.city
                    : props.item.objectFromCustomer}
            </p>
            <Tag
                className="w-32 text-center"
                color={
                    props.item.state === "created"
                        ? "blue"
                        : props.item.state === "declined"
                        ? "red"
                        : props.item.state === "completed"
                        ? "green"
                        : props.item.state === "waiting-for-customer-approval"
                        ? "gold-inverse"
                        : "gray"
                }>
                {props.item.state === "created"
                    ? "Erfasst"
                    : props.item.state === "declined"
                    ? "Abgelehnt"
                    : props.item.state === "completed"
                    ? "Abgeschlossen"
                    : props.item.state === "billed"
                    ? "Rechnung erstellt"
                    : props.item.state === "waiting-for-customer-approval"
                    ? "Wartet auf Zuarbeit"
                    : "In Bearbeitung"}
            </Tag>
        </div>
    )
}
